import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SEO, Reveal, Eyebrow } from "@/components/motion";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <main data-testid="faq-page">
      <SEO
        title="FAQ | HOMELARA Cleaning Services London - Areas, Products, Extras & Policies"
        description="Answers about HOMELARA cleaning services in London Zones 1 & 2: what's included, equipment, extras, Airbnb and office cleaning, rescheduling and cancellations."
      />

      <section className="mx-auto max-w-4xl px-5 sm:px-8 pt-32 sm:pt-44 pb-16">
        <Reveal>
          <Eyebrow>FAQ</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">
            Everything you'd want to ask, answered.
          </h1>
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-body">
            Can't find what you're looking for? <Link to="/contact" className="text-blue underline underline-offset-4">Get in touch</Link> - we're happy to help.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-4xl px-5 sm:px-8 pb-24">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-subtle">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="text-left font-sans text-base sm:text-lg font-medium text-ink hover:text-blue py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-body leading-relaxed pb-6 pr-8">
                  {f.a}
                  {(f.q.includes("reschedule") || f.q.includes("cancel")) && (
                    <Link to="/legal/cancellation-policy" className="mt-2 inline-block text-sm text-blue underline underline-offset-4">
                      Read the full policy
                    </Link>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-14">
          <div className="flex flex-col items-start justify-between gap-6 rounded-3xl bg-blue p-8 sm:p-10 text-canvas sm:flex-row sm:items-center">
            <h2 className="font-serif text-2xl sm:text-3xl tracking-tight">Still curious about something?</h2>
            <Link
              to="/contact"
              data-testid="faq-contact-button"
              className="inline-flex shrink-0 items-center gap-2 rounded-full bg-canvas px-8 py-4 font-mono text-xs uppercase tracking-[0.18em] text-blue transition-all duration-300 hover:-translate-y-0.5"
            >
              Get in Touch <ArrowUpRight size={14} />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
